import React from 'react';

export default function BusinessCardIcon({ className = "w-20 h-20" }) {
  return (
    <svg 
      className={className}
      viewBox="0 0 20.29 12.26" 
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <defs>
        <clipPath id="clippath">
          <rect fill="none" width="20.29" height="12.26" rx="1.09" ry="1.09"/>
        </clipPath>
        <clipPath id="clippath-1">
          <rect fill="none" x="-5" y="-5" width="30.29" height="22.26"/>
        </clipPath>
      </defs>
      <g>
        <g clipPath="url(#clippath)">
          <g clipPath="url(#clippath-1)">
            <image 
              width="64" 
              height="47" 
              transform="translate(-5.42 -5.14) scale(.48)" 
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAvCAYAAABUiRJEAAAACXBIWXMAABcRAAAXEQHKJvM/AAAGnElEQVRogeVaPXIdRRD+eqQMUUVmQYJVwilVHEBVdgLFHUgghzv4LmSYC5AA5gIOkCKs4jmxyw7QAaw3BG9ntufrr2clUqZqa9/O9HT317+7+9ZqrRU0nl3u8fOftzDgcFT036W6czUUAEf1cF3q+rufl/Wj/XJuB9a5To91vThac+tNTln0avp4Hdvv84uCs4vC8AAAZmbHfuLqXcWzy1tcva2wZa5ZxqBHNg9b1qpj0jYscxVAtXW90TflN2W4dXVc/7HHzQ44uzB89Gnk0sFfvat4+uv7TUHVKcMKDvNVA/GGaF7ya84WUReK0W2jGP7ZVdzsKr74pgQDFGAF7vlXC7KmYytC7jM46mYCpwZyhn/x4x43u5FjAYCfLm+jIA7V+DPQcYT7TSosPU/F1+q4HnJb8FjpLETo7jmBf/rbe1y+jSqbuY0EUCE0LEWIBK6b9J4stzufO4Rfp+nGWjl5Pje7OhigNOBs+erzz8WhYTWMUnoQiGgQlRahXkwGG5V5m5tnAxqA3fN93677AAkxyq9D0dvO7qx4qbD1NAGQAJN3n3GFdTcArxbvD60uAxDmKBc5PxWAlL+o4DIdRPtr863ns9e3WuYxT965p9YINCjGczUeoHn4ObUfEWSm5/DbOefV74fQP86KjIlN7dIfPm+GwiNAZkpyzg+RxUYQBuiGWCq8zHs6w+veJ5MwbL+LY+pBzSKCvaYOJavvqauiij6rEV235J5Ahv0sz4e5Gb04b9GHWuKHByR+W7WuZ1YcA/jAhJTR+WtReAJSeQXOo0NqGGB7N5fw6w81fc60nhSZHNXH3Cs9cDaCf4IaQHMh84J9IVvmiuPlDVPIkIXv8rh+hJyPKRnqgwe/BTx6drVyelDFHjzmhKs08HOtoIZIEF4f9qqiSDg1eLJYzK0x9FR48v7Z/MAnuWNTd2LG+vhOI8AqA4ytjoFXVtLW3BHhqDxkGY2iT3hB8DvMmdab6DtgzvlQFBLF/XzBeFe1hiABaHsnfd7LzlKI+bHXU2ML4EPYM2hkDOtYUX3IMuMsjwudtxSfH6vXM2dBXPsx5Hwa9g24K2TeSD5vPbCCMUpQl9zMQj/73fglXvdj8HhS7Iac5zugUaiNXhNhD7fejeBaXOZJjgCpJLVOdoY6ByPQuUXqca+SLKwBT8JK5ZYHo4C0qu37t3z7yoahNcWbU5Kv+d0h4B5pGTi8UNdOMgP0cG5rkxYIty/IoYgJMpfX5ZnXQ86LQreGvSpWrriF9iLalzLK8I590tqCbGEw9fg6RN2kMynQbRwHpgnwoe+qHJ7kmALVw5sNmFX6Chgs1Bo2kgeuQPv5tdrT285Z6ymLoFb81J42+rrLc3UTA7dfFUkPhMNdGXgGegVfLTJXwCnv+y0nKeo9ObQ1jPtZSXWt9nLUeZ374MhIokDe26fWZc8h0rKANI8n61nId96iUAKjHh4P6xTBc/iIUOdH0aA8F7YahTZeIdyrUJxoWKbUQexh2hW8rPa59+HmSqIwG8Sngn+/x8/rbAj/J0RWUwbjel4bwA/gaWHwFnvf5x8BlMDpUAq0NUrZYS1TvteFhHbLSCHs21B3WEAEDE+T5L2/zoyiHnaaXjKU2bNJm8togOU11gDCEbUNRmevSFCYiyEZxLNWHvPKqSJ1l3VJI+pPkcrjHofLTRbW/8z37ZJzmo0p+nEW2jPQd5kvU+DU47fu3TPjzOoCiB8sjygFZkbH4R7AdwaTvt1o+nM5xrUBQGKUoJC4ro5/GFsun9Dx1MnZYaZ4aynrFed1X4WBEeggJAGQGaHxkH99zXhOUmQ2PnjYwHPv3GgdoZomvXfIbSRGIhwDW2u08c/wNDruOB48WcA/OrXgSRYSch86z0JBsnE/00zTYeFZF+aq2G1Fmlp78GSNr/LDl0d4dGpRwSS3paLQQLyHKrs24aXmKp3/6zg5s+51YEmzrz9frZFVbVZKPUCkQAzrNz7t9jajDTJsuM5o0+EIPXBgAf/ZqeH7r450GPEdlboPbZfZHZ4DXL3FkkhgTyvy+0RBBXD+XemFrsvyn5/+9amilxd7vHxTZZ8u4jx8dkrX4VNUNYeczipwBBtfhzUZpBsX4wbzw4eG82/jH15mZqa+vX25GOH69WiEAJ4Aq29n2RgedKnL97eI4Ps+D97JbUZQ9yioB9CnTwwnD3WCpOC9Ea6XKLh+XfH36zqADx8Du+upt/184vnVmBb481ulZoBPHh88/PHj7Ypgxh/U/c/Gv38VLWPm1fF7AAAAAElFTkSuQmCC"
            />
          </g>
        </g>
        <line 
          stroke="currentColor" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth=".44" 
          fill="currentColor"
          x1="10.23" 
          y1="8.6" 
          x2="13.56" 
          y2="8.6"
        />
        <line 
          stroke="currentColor" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth=".44" 
          fill="currentColor"
          x1="10.23" 
          y1="6.43" 
          x2="18.23" 
          y2="6.43"
        />
        <path 
          fill="currentColor" 
          d="M5.37,7.18c.07.21-.08.35-.08.57,0,.31.14.68.11,1l.54-1.67c.04-.1.11-.09.2-.08.32.03,1.58.36,1.89.48.2.08.29.2.37.39.21.47.19,1,.23,1.5-.04.09-.12.13-.2.16-1.28.53-3.76.51-5.13.33-.6-.08-1.2-.22-1.77-.44-.02-.43,0-.89.12-1.31.14-.49.19-.57.67-.72.56-.17,1.14-.27,1.7-.41l.09.02.54,1.73.14-1.04c0-.07-.21-.52-.05-.52h.6Z"
        />
        <path 
          fill="currentColor" 
          d="M4.77,2.53c2.02-.2,2.04,2.1,1.25,3.37-.62,1-1.57.84-2.1-.13-.6-1.08-.81-3.07.85-3.24Z"
        />
        <line 
          stroke="currentColor" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth=".44" 
          fill="currentColor"
          x1="10.23" 
          y1="4.26" 
          x2="18.23" 
          y2="4.26"
        />
      </g>
    </svg>
  );
}

